import { render, staticRenderFns } from "./MassOpenDoorSoundUploadPanel.vue?vue&type=template&id=0d87f1b6&scoped=true"
import script from "./MassOpenDoorSoundUploadPanel.vue?vue&type=script&lang=js"
export * from "./MassOpenDoorSoundUploadPanel.vue?vue&type=script&lang=js"
import style0 from "./MassOpenDoorSoundUploadPanel.vue?vue&type=style&index=0&id=0d87f1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d87f1b6",
  null
  
)

export default component.exports